import ConfirmModal from "components/confirm-modal";
import messages from "messages";

type Props = {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const CancelUploadConfirmModal = (props: Props) => (
  <ConfirmModal
    labelTitle={messages.cancelUploadAsk}
    children={messages.yourUploadIsNotComplete}
    labelConfirm={messages.cancelUpload}
    labelCancel={messages.continueUpload}
    {...props}
  />
);

export default CancelUploadConfirmModal;
